import { render, staticRenderFns } from "./SCGrouping.vue?vue&type=template&id=ef44c3a6&scoped=true"
import script from "./SCGrouping.vue?vue&type=script&lang=js"
export * from "./SCGrouping.vue?vue&type=script&lang=js"
import style0 from "./SCGrouping.vue?vue&type=style&index=0&id=ef44c3a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef44c3a6",
  null
  
)

export default component.exports